import { useMutation, useQuery } from "react-query";

import { api } from "../utils";

import { useAuth } from "./useAuth";

export interface IUseGetCustomerAddressByIdParameters {
    addressId: string;
}

export const useGetCustomerAddressById = () => {
    const auth = useAuth();

    const {
        mutateAsync,
        mutate,
        isIdle,
        isLoading,
        data,
        error,
        isError,
        isSuccess,
    } = useMutation({
        mutationFn: (parameters: IUseGetCustomerAddressByIdParameters) => {
            if (!auth.token) {
                throw new Error(
                    "Cannot get customer addresses without valid token.",
                );
            }

            return api.addresses.getCustomerAddressById({
                addressId: parameters.addressId,
                token: auth.token,
            });
        },
    });

    return {
        mutateAsync,
        mutate,
        isIdle,
        isLoading,
        data,
        error,
        isError,
        isSuccess,
    };
};
